import type * as ProgressPrimitive from "@radix-ui/react-progress";
import type { ComponentPropsWithoutRef, ComponentRef } from "react";

import { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const PROGRESS_MAX = 100;

export const PROGRESS_ROOT_CLASS = "relative h-2 w-full overflow-hidden rounded-full bg-component-progress-track";

export const PROGRESS_INDICATOR_CLASS = "size-full bg-component-progress-indicator transition-transform";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TProgressElement = ComponentRef<typeof ProgressPrimitive.Root>;

export type TProgressProps = ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>;

type TProgressDefaultProps = DefinedDefaults<TProgressProps, "value" | "max">;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const PROGRESS_DEFAULTS = {
  value: 0,
  max: PROGRESS_MAX,
} satisfies TProgressDefaultProps;
